import { lazy } from 'react'

import ManageUsersLoader from './loader'

export default {
  ManageUsers: {
    Component: lazy(() => import('./ManageUsers.Page')),
    Loader: ManageUsersLoader,
  },
}
